import { PhoneCall, Star } from 'lucide-react';

export default function ContentBlock({
  subtitle,
  title,
  description,
  extraText,
  buttonText,
  background = 'white',
}) {
  return (
    <section className={`bg-${background} py-[80px] px-4`}>
      <div className="max-w-[900px] mx-auto text-center space-y-8">
        {/* Stars */}
        <div className="flex justify-center mb-4">
          {[...Array(5)].map((_, i) => (
            <Star key={i} className="w-6 h-6 mr-2 fill-primary text-transparent" />
          ))}
        </div>

        {/* Subtitle */}
        {subtitle && (
          <h2 className="uppercase tracking-[6px] text-lg text-gray font-light">
            {subtitle}
          </h2>
        )}

        {/* Title */}
        <h3 className="text-4xl font-light text-black leading-tight font-gilda">
          {title}
        </h3>

        {/* Description */}
        <p className="text-gray font-light text-lg leading-relaxed">
          {description}
        </p>

        {/* Extra Text */}
        {extraText && (
          <p className="text-gray font-light text-lg leading-relaxed">
            {extraText}
          </p>
        )}

        <div className="text-center mt-12">
          <a
            href="/contact"
            className="inline-block text-lg uppercase py-3 px-8 bg-primary text-white font-base hover:bg-black transition-all duration-500 ease-in-out"
          >
            {buttonText}
          </a>
        </div>
        
      </div>
    </section>
  );
}
